export const KeyEventCodes = {
  data: () => ( {
    keyboardEvent: {
      keyCode: {
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        ENTER: 13,
        SHIFT: 16,
        BACKSPACE: 8,
        CTRL: 7,
        TAB: 9,
        DELETE: 46,
      },
    },
  } ),
};

export const navigation = {
  methods: {
    back () {
      window.history.go( -1 );
    },
    redirect ( url ) {
      window.location.href = url;
    },
  },
};

export const utils = {
  methods: {
    isNullOrEmpty ( val ) {
      return val == null || val === "";
    },
    animateScrollToTop ( interval = 20, step = 20 ) {
      const offset = window.pageYOffset;
      window.scrollTo( 0, offset - step );

      if ( offset > 0 ) {
        window.setTimeout( this.scrollToTop, interval );
      }
    },
  },
};

export const breakpoints = {
  data: () => ( {
    queries: {
      mobile: null,
      tablet: null,
    },
    isMobile: false,
    isTablet: false,
  } ),
  mounted () {
    this.queries.mobile = window.matchMedia( "(max-width: 767px)" );
    if ( typeof this.queries.mobile?.addEventListener === "function" ) {
      this.queries.mobile.addEventListener( "change", this.updateIsMobile );
    }

    this.queries.tablet = window.matchMedia( "(max-width: 991px)" );
    if ( typeof this.queries.tablet?.addEventListener === "function" ) {
      this.queries.tablet.addEventListener( "change", this.updateIsTablet );
    }

    this.updateIsMobile();
    this.updateIsTablet();
  },
  beforeDestroy () {
    if ( typeof this.queries.mobile?.removeEventListener === "function" ) {
      this.queries.mobile.removeEventListener( "change", this.updateIsMobile );
    }
    if ( typeof this.queries.tablet?.removeEventListener === "function" ) {
      this.queries.tablet.removeEventListener( "change", this.updateIsTablet );
    }
  },
  methods: {
    updateIsMobile () {
      if ( typeof this.queries.mobile?.matches === "boolean" ) {
        this.isMobile = this.queries.mobile.matches;
      }
    },
    updateIsTablet () {
      if ( typeof this.queries.tablet?.matches === "boolean" ) {
        this.isTablet = this.queries.tablet.matches;
      }
    },
  },
};
